<div
  [formGroup]="formGroup"
  class="form-group"
  [class.has-error]="!isValid(formGroup, ctrl)"
  [libCtrConfigUI]="ctrl" [altura]="ctrl?.Altura"
  [isMobile]="isMobile"
  [class.black]="enTheme === ENTHEME.black">
    <div class="col-sm-10">
      <section class="section" [class.is-desktop-section]="!isMobile">
        <span class="list-section" [ngSwitch]="isMobile" *ngIf="ctrl?.ShowRotulo !== false">
          <ng-container *ngSwitchCase="false">
            <lib-title-label
              [formGroup]="formGroup"
              [isMobile]="isMobile"
              [enTheme]="enTheme"
              [ctrl]="ctrl">
            </lib-title-label>
          </ng-container>

          <ng-container *ngSwitchDefault>
            <mat-checkbox
              class="margin"
              [checked]="allComplete"
              [indeterminate]="someComplete()"
              (change)="setAll($event.checked, ctrl)"
              [disabled]="!ctrl.IsEnable">
                <lib-title-label
                  [formGroup]="formGroup"
                  [isMobile]="isMobile"
                  [enTheme]="enTheme"
                  [ctrl]="ctrl">
                </lib-title-label>
            </mat-checkbox>
          </ng-container>
        </span>

        <span class="list-section">
          <ul *ngIf="(checklistItems$ | async) as items"
            [class.is-desktop-ul]="!isMobile"
            [style.grid-template-columns]="!isMobile ? 'repeat(' + ctrl.NumberOfColumn + ', ' + ctrl.ColumnWidth + 'px)' : null">
              <li *ngFor="let item of items" [libCtrlGridColumn]="ctrl" [isMobile]="isMobile">
                <mat-checkbox
                  [checked]="item.checked"
                  (change)="onItemChange($event.checked, item, ctrl)"
                  color="primary"
                  [class.is-mobile]="isMobile"
                  [disabled]="!ctrl.IsEnable">
                    {{ item?.label }}
                </mat-checkbox>
              </li>
          </ul>
        </span>
      </section>
    </div>
</div>
